import { MegaMenuConfigFile } from "@/components/mega-menu/types";
import { MANAGED_FORMS_URL } from "@/utils/managed-forms";
import { MANAGED_PLATFORM_URL } from "@/utils/managed-platform";
import { COSMETIC_CAREERS_URL } from "@/utils/cosmetic-careers";
import { COSMETIC_COLLEGE_APP_PAGE_PATH } from "@/utils/student-app";
import { withAccountUtm } from "@/utils/account-utm";
import { TRAINING_PERSONAS, TRAINING_HUB_PATH } from "@/config/training-personas";

export const megaMenuConfig: MegaMenuConfigFile = {
  menus: [
    {
      id: "training",
      label: "Training",
      url: "/courses/",
      badge: null,
      helperText:
        "Explore professional training from beginner to advanced level - with clear progression and support",
      featuredCards: [
        {
          title: "VTCT Level 3 Access to Aesthetics",
          subtitle: null,
          url: "/courses/vtct/level-3-certificate-in-access-to-aesthetic-therapies/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/6FlTABBmzpWnj0IUbhPwbe/VTCT_FACIAL_MASSAGE.jpg",
          imageAlt: "VTCTLevel 3 Access to Aesthetics",
        },
        {
          title: "VTCT Level 4 Certificate in Laser Hair Removal & IPL",
          subtitle: null,
          url: "/courses/vtct/laser-hair-removal/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/4Fd21vgbsimRH63rXx4ctc/shutterstock_435284326.jpg",
          imageAlt:
            "VTCT Level 4 Certificate in Advanced Aesthetic Therapies for Skin Rejuvenation",
        },
        {
          title:
            "VTCT Level 4 Certificate in Advanced Aesthetic Therapies for Skin Rejuvenation",
          subtitle: null,
          url: "/courses/vtct/level-4-certificate-in-advanced-aesthetic-therapies-for-skin/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/1BHmEBy9fH4X8ZXE1SD4PP/shutterstock_2105495051.jpg",
          imageAlt:
            "VTCT Level 4 Certificate in Advanced Aesthetic Therapies for Skin Rejuvenation",
        },
        {
          title:
            "VTCT Level 5 Certificate in Non-surgical Aesthetic Procedures for Skin Rejuvenation",
          subtitle: null,
          url: "/courses/vtct/level-5-certificate-in-non-surgical-aesthetic-procedures-for-skin/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/3u1dXBGdF3eXmJk7LYjRD3/shutterstock_2140727647-2.jpg",
          imageAlt:
            "VTCT Level 5 Certificate in Non-surgical Aesthetic Procedures for Skin Rejuvenation",
        },
        {
          title:
            "VTCT Level 7 Diploma in Non-surgical Aesthetic Injectable Procedures",
          subtitle: null,
          url: "/courses/vtct/level-7-diploma-in-non-surgical-aesthetic-injectable-procedures/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/29nCboKyhhb2xhgQZy6YzV/Youtube_Landscape.00_02_31_24.Still014__1_.jpg",
          imageAlt:
            "VTCT Level 7 Diploma in Non-surgical Aesthetic Injectable Procedures",
        },
      ],
      linkGroups: [
        {
          heading: "Start Here",
          headingUrl: null,
          items: [
            {
              label: "Find your training route",
              url: TRAINING_HUB_PATH,
            },
            ...TRAINING_PERSONAS.map(({ label, href }) => ({
              label,
              url: href,
            })),
          ],
        },
        {
          heading: "Qualification Types",
          headingUrl: null,
          items: [
            {
              label: "Professional Qualifications (VTCT)",
              url: "/courses/vtct/",
            },
            {
              label: "Short CPD Courses",
              url: "/courses/cpd/",
            },
            {
              label: "CPD to Regulated Qualification",
              url: "/courses/rpl/",
            },
            {
              label: "Build Your CPD Package",
              url: "/build-your-cpd-package/",
              badge: "New",
            },
            {
              label: "Online Courses",
              url: "/courses/elearning/",
            },
            {
              label: "Course Prices",
              url: "/course-prices/",
            },
          ],
        },
        {
          heading: "Popular Categories",
          headingUrl: null,
          items: [
            {
              label: "Aesthetics Training",
              url: "/courses/aesthetics/",
            },
            {
              label: "Medical Professionals",
              url: "/courses/medical-professionals/",
            },
            {
              label: "Hairdressing Training",
              url: "/courses/hair/",
            },
            {
              label: "Beauty Training",
              url: "/courses/beauty/",
            },
            {
              label: "Permanent Makeup Training",
              url: "/courses/semi-permanent-makeup/",
            },
            {
              label: "Education Training",
              url: "/courses/education/",
            },
          ],
        },
        {
          heading: "Most Popular",
          headingUrl: null,
          items: [
            {
              label: "Build Your CPD Package",
              url: "/build-your-cpd-package/",
              badge: "£999",
            },
            {
              label: "Training Calendar",
              url: "/training-course-calendar/",
            },
            {
              label: "Last Minute Offers",
              url: "/last-minute-offers/",
            },
            {
              label: "VTCT Laser Hair Removal",
              url: "/courses/vtct/laser-hair-removal/",
            },
            {
              label: "VTCT Level 7 Diploma",
              url: "/courses/vtct/level-7-diploma-in-non-surgical-aesthetic-injectable-procedures/",
            },
            {
              label: "VTCT Level 7 Certificate",
              url: "/courses/vtct/level-7-certificate-in-non-surgical-aesthetic-injectable-procedures/",
            },
            {
              label: "Microblading",
              url: "/courses/vtct/level-4-certificate-in-enhancing-eyebrows-with-microblading-techniques/",
            },
            {
              label: "Laser Tattoo Removal",
              url: "/courses/vtct/level-5-certificate-in-laser-tattoo-removal/",
            },
            {
              label: "VTCT Access to Aesthetics",
              url: "/courses/vtct/level-3-certificate-in-access-to-aesthetic-therapies/",
            },
          ],
        },
      ],
      viewAll: {
        label: "View all training courses",
        url: "/courses/",
      },
    },
    {
      id: "fast-track",
      label: "Fast Track",
      url: "/courses/fast-track-training/",
      badge: "Popular",
      helperText:
        "Qualify in weeks, not years with accelerated VTCT training. Intensive delivery with structured support and tutor guidance",
      featuredCards: [
        {
          title: "VTCT Level 3 Access to Aesthetics",
          subtitle: null,
          url: "/courses/vtct/level-3-certificate-in-access-to-aesthetic-therapies/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/6FlTABBmzpWnj0IUbhPwbe/VTCT_FACIAL_MASSAGE.jpg",
          imageAlt: "VTCTLevel 3 Access to Aesthetics",
        },
        {
          title: "VTCT Level 4 Certificate in Laser Hair Removal & IPL",
          subtitle: null,
          url: "/courses/vtct/laser-hair-removal/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/4Fd21vgbsimRH63rXx4ctc/shutterstock_435284326.jpg",
          imageAlt:
            "VTCT Level 4 Certificate in Advanced Aesthetic Therapies for Skin Rejuvenation",
        },
        {
          title:
            "VTCT Level 4 Certificate in Advanced Aesthetic Therapies for Skin Rejuvenation",
          subtitle: null,
          url: "/courses/vtct/level-4-certificate-in-advanced-aesthetic-therapies-for-skin/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/1BHmEBy9fH4X8ZXE1SD4PP/shutterstock_2105495051.jpg",
          imageAlt:
            "VTCT Level 4 Certificate in Advanced Aesthetic Therapies for Skin Rejuvenation",
        },
        {
          title:
            "VTCT Level 5 Certificate in Non-surgical Aesthetic Procedures for Skin Rejuvenation",
          subtitle: null,
          url: "/courses/vtct/level-5-certificate-in-non-surgical-aesthetic-procedures-for-skin/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/3u1dXBGdF3eXmJk7LYjRD3/shutterstock_2140727647-2.jpg",
          imageAlt:
            "VTCT Level 5 Certificate in Non-surgical Aesthetic Procedures for Skin Rejuvenation",
        },
        {
          title:
            "VTCT Level 7 Diploma in Non-surgical Aesthetic Injectable Procedures",
          subtitle: null,
          url: "/courses/vtct/level-7-diploma-in-non-surgical-aesthetic-injectable-procedures/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/29nCboKyhhb2xhgQZy6YzV/Youtube_Landscape.00_02_31_24.Still014__1_.jpg",
          imageAlt:
            "VTCT Level 7 Diploma in Non-surgical Aesthetic Injectable Procedures",
        },
      ],
      linkGroups: [
        {
          heading: "Fast Track Highlights",
          headingUrl: null,
          items: [
            {
              label: "5 Day Aesthetic Career Accelerator",
              url: "/aesthetic-career-accelerator/",
            },
            {
              label: "Fast Track Hairdressing (VTCT Level 2)",
              url: "/courses/vtct/vtct-level-2-certificate-in-womens-hairdressing/",
            },
            {
              label: "VTCT Aesthetics Fast Track",
              url: "/pathway-to-aesthetics/",
              badge: "Popular",
            },
            {
              label: "Level 3 Access to Aesthetics",
              url: "/courses/vtct/level-3-certificate-in-access-to-aesthetic-therapies/",
            },
          ],
        },
        {
          heading: "Fast Track by Goal",
          headingUrl: null,
          items: [
            {
              label: "Start a new career",
              url: "/courses/career-change/",
            },
            {
              label: "CPD to Regulated Qualification",
              url: "/courses/rpl/",
            },
            {
              label: "Get qualified quickly",
              url: "/courses/fast-track-training/",
            },
            {
              label: "Progress to injectables",
              url: "/pathway-to-aesthetics/",
            },
            {
              label: "For Medical Professionals",
              url: "/courses/medical-professionals/",
            },
          ],
        },
        {
          heading: "Fast Track Skin & Laser",
          headingUrl: null,
          items: [
            {
              label: "Laser Hair Removal",
              url: "/courses/vtct/laser-hair-removal/",
            },
            {
              label: "Laser Tattoo Removal",
              url: "/courses/vtct/level-5-certificate-in-laser-tattoo-removal/",
            },
            {
              label: "Level 4 Aesthetics",
              url: "/courses/vtct/level-4-certificate-in-advanced-aesthetic-therapies-for-skin/",
            },
          ],
        },
        {
          heading: "Career Packages",
          headingUrl: "/courses/packages/",
          items: [
            {
              label: "Advanced Aesthetics Career Package",
              url: "/courses/packages/advanced-aesthetics-career-package/",
            },
            {
              label: "Permanent Makeup Career Package",
              url: "/courses/packages/permanent-makeup-career-package/",
            },
            {
              label: "VTCT Level 3 Massage Package",
              url: "/courses/packages/vtct-level-3-massage-package/",
            },
          ],
        },
      ],
      viewAll: {
        label: "View all fast track training",
        url: "/courses/fast-track-training/",
      },
      mobilePinned: true,
    },
    {
      id: "aesthetics",
      label: "Aesthetics",
      url: "/courses/aesthetics/",
      badge: null,
      helperText:
        "Structured progression from entry-level to advanced aesthetics practice.",
      featuredCards: [
        {
          title: "VTCT Level 3 Access to Aesthetics",
          subtitle: null,
          url: "/courses/vtct/level-3-certificate-in-access-to-aesthetic-therapies/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/6FlTABBmzpWnj0IUbhPwbe/VTCT_FACIAL_MASSAGE.jpg",
          imageAlt: "VTCTLevel 3 Access to Aesthetics",
        },
        {
          title: "VTCT Level 4 Certificate in Laser Hair Removal & IPL",
          subtitle: null,
          url: "/courses/vtct/laser-hair-removal/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/4Fd21vgbsimRH63rXx4ctc/shutterstock_435284326.jpg",
          imageAlt:
            "VTCT Level 4 Certificate in Advanced Aesthetic Therapies for Skin Rejuvenation",
        },
        {
          title:
            "VTCT Level 4 Certificate in Advanced Aesthetic Therapies for Skin Rejuvenation",
          subtitle: null,
          url: "/courses/vtct/level-4-certificate-in-advanced-aesthetic-therapies-for-skin/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/1BHmEBy9fH4X8ZXE1SD4PP/shutterstock_2105495051.jpg",
          imageAlt:
            "VTCT Level 4 Certificate in Advanced Aesthetic Therapies for Skin Rejuvenation",
        },
        {
          title:
            "VTCT Level 5 Certificate in Non-surgical Aesthetic Procedures for Skin Rejuvenation",
          subtitle: null,
          url: "/courses/vtct/level-5-certificate-in-non-surgical-aesthetic-procedures-for-skin/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/3u1dXBGdF3eXmJk7LYjRD3/shutterstock_2140727647-2.jpg",
          imageAlt:
            "VTCT Level 5 Certificate in Non-surgical Aesthetic Procedures for Skin Rejuvenation",
        },
        {
          title:
            "VTCT Level 7 Diploma in Non-surgical Aesthetic Injectable Procedures",
          subtitle: null,
          url: "/courses/vtct/level-7-diploma-in-non-surgical-aesthetic-injectable-procedures/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/29nCboKyhhb2xhgQZy6YzV/Youtube_Landscape.00_02_31_24.Still014__1_.jpg",
          imageAlt:
            "VTCT Level 7 Diploma in Non-surgical Aesthetic Injectable Procedures",
        },
      ],
      linkGroups: [
        {
          heading: "Qualifications",
          headingUrl: "/courses/vtct/",
          items: [
            {
              label: "Level 3 Access to Aesthetics",
              url: "/courses/vtct/level-3-certificate-in-access-to-aesthetic-therapies/",
            },
            {
              label: "Level 4 Aesthetic Therapies for Skin Rejuvenation",
              url: "/courses/vtct/level-4-certificate-in-advanced-aesthetic-therapies-for-skin/",
            },
            {
              label: "Level 5 Aesthetic Procedures for Skin Rejuvenation",
              url: "/courses/vtct/level-5-certificate-in-non-surgical-aesthetic-procedures-for-skin/",
            },
            {
              label: "Level 7 Diploma in Injectable Procedures",
              url: "/courses/vtct/level-7-diploma-in-non-surgical-aesthetic-injectable-procedures/",
            },
            {
              label: "Level 7 Certificate in Injectable Procedures",
              url: "/courses/vtct/level-7-certificate-in-non-surgical-aesthetic-injectable-procedures/",
            },
            {
              label: "View all VTCT qualifications",
              url: "/courses/vtct/",
            },
          ],
        },
        {
          heading: "Injectables",
          headingUrl: "/courses/cpd/",
          items: [
            {
              label: "Anti-Wrinkle Injections",
              url: "/courses/aesthetics/foundation-anti-wrinkle-injections-course/",
            },
            {
              label: "Dermal Fillers",
              url: "/courses/aesthetics/foundation-dermal-fillers/",
            },
            {
              label: "Skin Boosters",
              url: "/courses/aesthetics/skin-boosters/",
            },
            {
              label: "Polynucleotides",
              url: "/courses/aesthetics/polynucleotides-skin-rejuvenation/",
            },
            {
              label: "View all injectables CPD",
              url: "/courses/cpd/",
            },
          ],
        },
        {
          heading: "Skin & Devices",
          headingUrl: "/courses/vtct/",
          items: [
            {
              label: "Laser Hair Removal",
              url: "/courses/vtct/laser-hair-removal/",
            },
            {
              label: "Tattoo Removal",
              url: "/courses/vtct/level-5-certificate-in-laser-tattoo-removal/",
            },
            {
              label: "Microneedling",
              url: "/courses/vtct/level-4-in-skin-microneedling/",
            },
            {
              label: "Mesotherapy",
              url: "/courses/vtct/level-6-award-in-mesotherapy-treatments/",
            },
            {
              label: "View all skin & device courses",
              url: "/courses/vtct/",
            },
          ],
        },
      ],
      viewAll: {
        label: "View all aesthetics",
        url: "/courses/aesthetics/",
      },
    },
    {
      id: "beauty",
      label: "Beauty",
      url: "/courses/beauty/",
      badge: null,
      helperText:
        "Build a strong foundation in beauty before progressing into aesthetics and advanced skin treatments. Suitable for beginners with no prior experience.",
      featuredCards: [
        {
          title: "VTCT Level 3 Access to Aesthetics",
          subtitle: null,
          url: "/courses/vtct/level-3-certificate-in-access-to-aesthetic-therapies/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/6FlTABBmzpWnj0IUbhPwbe/VTCT_FACIAL_MASSAGE.jpg",
          imageAlt: "VTCTLevel 3 Access to Aesthetics",
        },
        {
          title: "Chemical Skin Peels Training",
          subtitle: null,
          url: "/courses/aesthetics/chemical-skin-peels/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/59rbWh4MVuoa5G8GQ3FoBV/Untitled_design__15_.png",
          imageAlt: "Chemical Skin Peels Training",
        },
        {
          title: "Lymphatic Drainage Massage Training Course",
          subtitle: null,
          url: "/courses/beauty/lymphatic-drainage-massage/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/1GbfeqG0LKZBze8uwukvAz/Lymphatic_massage.jpg",
          imageAlt: "Lymphatic Drainage Massage Training Course",
        },
        {
          title: "Plasma Fibroblast Skin Tightening Training",
          subtitle: null,
          url: "/courses/aesthetics/plasma-fibroblast-skin-tightening/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/3bfWR9RwOYh34ZTpjmrZy/facial_blast.jpg",
          imageAlt: "Plasma Fibroblast Skin Tightening Training",
        },
        {
          title: "Body Contouring Training",
          subtitle: null,
          url: "/courses/beauty/radiofrequency-ultrasound-cavitation-fat-reduction-and-skin-tightening-training/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/59pypGIFtTsDBgrCxQcfn4/radio_frequency_.jpg",
          imageAlt: "Body Contouring Training",
        },
      ],
      linkGroups: [
        {
          heading: "Beauty Qualifications",
          headingUrl: "/courses/beauty/",
          items: [
            {
              label: "VTCT Level 3 Access to Aesthetics",
              url: "/courses/vtct/level-3-certificate-in-access-to-aesthetic-therapies/",
            },
            {
              label:
                "VTCT Level 4 Certificate in Advanced Aesthetic Therapies for Skin Rejuvenation",
              url: "/courses/vtct/level-4-certificate-in-advanced-aesthetic-therapies-for-skin/",
            },
            {
              label:
                "VTCT Level 5 Certificate in Non-Surgical Aesthetic Procedures for Skin",
              url: "/courses/vtct/level-5-certificate-in-non-surgical-aesthetic-procedures-for-skin/",
            },
          ],
        },
        {
          heading: "Popular Beauty Training",
          headingUrl: "/courses/beauty/",
          items: [
            {
              label: "Chemical Skin Peels Training",
              url: "/courses/aesthetics/chemical-skin-peels/",
            },
            {
              label: "Microneedling Training",
              url: "/courses/aesthetics/microneedling/",
            },
            {
              label: "Dermaplaning Training",
              url: "/courses/beauty/dermaplaning/",
            },
            {
              label: "Cryotherapy Fat Freezing Training",
              url: "/courses/beauty/cryotherapy-fat-freezing/",
            },
          ],
        },
        {
          heading: "Enhanced Beauty Training",
          headingUrl: "/courses/beauty/",
          items: [
            {
              label: "Plasma Fibroblast Skin Tightening Training",
              url: "/courses/aesthetics/plasma-fibroblast-skin-tightening/",
            },
            {
              label:
                "Radiofrequency Ultrasound Cavitation Fat Reduction and Skin Tightening Training",
              url: "/courses/beauty/radiofrequency-ultrasound-cavitation-fat-reduction-and-skin-tightening-training/",
            },
            {
              label: "Lymphatic Drainage Massage Training Course",
              url: "/courses/beauty/lymphatic-drainage-massage/",
            },
          ],
        },
      ],
      viewAll: {
        label: "View all beauty training courses",
        url: "/courses/beauty/",
      },
    },
    {
      id: "hairdressing",
      label: "Hairdressing",
      url: "/courses/hair/",
      badge: null,
      helperText:
        "Start in hair or use it as a gateway into aesthetics and advanced beauty careers. Suitable for beginners. No prior experience required.",
      featuredCards: [
        {
          title: "VTCT Level 2 Fast Track Women's Hairdressing",
          subtitle: null,
          url: "/courses/vtct/vtct-level-2-certificate-in-womens-hairdressing/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/1GISGDKv1gUkwpwdR76uQz/female-hairdresser-beauty-salon_1303-27755.jpg",
          imageAlt: "VTCT Level 2 Fast Track Women's Hairdressing",
        },
        {
          title: "Extension Cutting, Blending & Styling Masterclass",
          subtitle: null,
          url: "/courses/beauty/extension-cutting-blending-and-styling-masterclass/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/3ULhN3SHW88j2dGgNrmZmL/Extension_Cutting__Blending___Styling_Masterclass.jpg",
          imageAlt: "Extension Cutting, Blending & Styling Masterclass",
        },
        {
          title: "6 Method Hair Extensions Masterclass",
          subtitle: null,
          url: "/courses/beauty/hair-extensions-masterclass/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/4OSXBgzaN6ViRCzyqbv6t0/8_Method_Hair_Extensions_Masterclass.jpg",
          imageAlt: "6 Method Hair Extensions Masterclass",
        },
        {
          title: "Complete Hair Extension & Styling Mastery Course",
          subtitle: null,
          url: "/courses/beauty/complete-hair-extension-and-styling-mastery-course/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/1m0HDaS5gDdKQphLaOut8X/Hair_Extension_Training.jpg",
          imageAlt: "Complete Hair Extension & Styling Mastery Course",
        },
      ],
      linkGroups: [
        {
          heading: "Hairdressing Qualifications",
          headingUrl: "/courses/hair/",
          items: [
            {
              label: "Fast Track Level 2 Hairdressing",
              url: "/courses/vtct/vtct-level-2-certificate-in-womens-hairdressing/",
            },
            {
              label: "VTCT Level 2 Women's Hairdressing",
              url: "/courses/vtct/vtct-level-2-certificate-in-womens-hairdressing/",
            },
          ],
        },
        {
          heading: "Hair Extension Masterclasses",
          headingUrl: null,
          items: [
            {
              label: "6 Method Hair Extensions Masterclass",
              url: "/courses/beauty/hair-extensions-masterclass/",
            },
            {
              label: "Extension Cutting, Blending & Styling Masterclass",
              url: "/courses/beauty/extension-cutting-blending-and-styling-masterclass/",
            },
            {
              label: "Complete Hair Extension & Styling Mastery Course",
              url: "/courses/beauty/complete-hair-extension-and-styling-mastery-course/",
            },
          ],
        },
        {
          heading: "Hairdressing Insights",
          headingUrl: null,
          items: [
            {
              label: "How to Become a Hair Stylist",
              url: "/become-a-hair-stylist",
            },
          ],
        },
      ],
      viewAll: {
        label: "View all hairdressing training courses",
        url: "/courses/hair/",
      },
    },
    {
      id: "permanent-makeup",
      label: "Permanent Makeup",
      url: "/courses/semi-permanent-makeup/",
      badge: null,
      helperText:
        "Structured progression from entry-level to advanced permanent makeup practice.",
      featuredCards: [
        {
          title: "VTCT Level 4 Micropigmentation",
          subtitle: null,
          url: "/courses/vtct/level-4-certificate-in-micropigmentation/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/55dzmvNLOk5pkT5gbLAAat/4.png",
          imageAlt: "VTCT Level 4 Micropigmentation",
        },
        {
          title: "VTCT Level 4 Microblading",
          subtitle: null,
          url: "/courses/vtct/level-4-certificate-in-enhancing-eyebrows-with-microblading-techniques/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/7eihTWsHeY8qorsyy0ZW8M/2.png",
          imageAlt:
            "VTCT Level 4 Certificate in Enhancing Eyebrows with Microblading Techniques",
        },
        {
          title: "Ombre Brows Training",
          subtitle: null,
          url: "/courses/semi-permanent-makeup/ombre-brows/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/2JSq9yNyobEFxQfHuJhatg/IMG_2276.JPG",
          imageAlt: "Ombre Brows Training",
        },
        {
          title: "Lip Blush Training",
          subtitle: null,
          url: "/courses/semi-permanent-makeup/lip-blush-training/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/6xLIn6Pwwj7aDZ8WckVeHH/Screenshot_2022-06-23_at_13.32.39.png",
          imageAlt: "Lip Blush Training",
        },
        {
          title: "Eyeliner & Lash Enhancement Masterclass Training",
          subtitle: null,
          url: "/courses/semi-permanent-makeup/eyeliner-and-lash-enhancements/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/1BXztkaAdMAVGlgIFjKu2X/IMG_2606_2.JPG",
          imageAlt: "Eyeliner & Lash Enhancement Masterclass Training",
        },
      ],
      linkGroups: [
        {
          heading: "Qualifications",
          headingUrl: "/courses/semi-permanent-makeup/",
          items: [
            {
              label: "VTCT Level 4 Micropigmentation",
              url: "/courses/vtct/level-4-certificate-in-micropigmentation/",
            },
            {
              label: "VTCT Level 4 Microblading",
              url: "/courses/vtct/level-4-certificate-in-enhancing-eyebrows-with-microblading-techniques/",
            },
          ],
        },
        {
          heading: "Skill Enhancement Masterclasses",
          headingUrl: "/courses/semi-permanent-makeup/",
          items: [
            {
              label: "Ombre Brows Training",
              url: "/courses/semi-permanent-makeup/ombre-brows/",
            },
            {
              label: "Lip Blush Training",
              url: "/courses/semi-permanent-makeup/lip-blush-training/",
            },
            {
              label: "Eyeliner & Lash Enhancement Masterclass Training",
              url: "/courses/semi-permanent-makeup/eyeliner-and-lash-enhancements/",
            },
          ],
        },
        {
          heading: "Insights",
          headingUrl: null,
          items: [
            {
              label: "How to Become a Permanent Makeup Artist",
              url: "/blog/how-to-become-a-permanent-makeup-artist/",
            },
            {
              label: "Guide to Becoming a Certified Microblading Artist",
              url: "/blog/a-guide-on-how-to-become-a-certified-microblading-artist/",
            },
          ],
        },
      ],
      viewAll: {
        label: "View all permanent makeup courses",
        url: "/courses/semi-permanent-makeup/",
      },
    },
    {
      id: "online",
      label: "Online Courses",
      url: "/courses/elearning/",
      badge: "3 for 2",
      helperText:
        "Flexible online learning with structured support and progression. Ideal for theory, CPD and progression. Practical qualifications require in-person training.",
      featuredCards: [
        {
          title:
            "Online VTCT Level 3 Award in Anatomical and Physiological Knowledge of Body Systems",
          subtitle: null,
          url: "/courses/elearning/vtct-level-3-award-in-anatomical-and-physiological-knowledge-of-body",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/bY468pHUh9Wf9GYU8GtAt/5197.webp",
          imageAlt:
            "Online VTCT Level 3 Award in Anatomical and Physiological Knowledge of Body Systems",
        },
        {
          title:
            "Online VTCT Level 4 Award in Core of Knowledge for Laser and Light Devices",
          subtitle: null,
          url: "/courses/elearning/vtct-itec-level-4-award-in-core-of-knowledge-for-laser-and-light-devices",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/4Fd21vgbsimRH63rXx4ctc/shutterstock_435284326.jpg",
          imageAlt:
            "VTCT (ITEC) Level 4 Award in Core of Knowledge for Laser and Light Devices",
        },
        {
          title:
            "Online VTCT Level 4 Award in Principles and Practice of Aesthetic Therapies",
          subtitle: null,
          url: "/courses/elearning/vtct-itec-level-4-award-in-principles-and-practice-of-aesthetic-therapies",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/4sHqFuUEHwOrs4TUb4wLXd/iNJECTOR_TRAINING___COSMETIC_COLLEGE_2.jpg",
          imageAlt:
            "Online VTCT Level 4 Award in Principles and Practice of Aesthetic Therapies",
        },
        {
          title: "Online Lemon Bottle Skin Booster Training",
          subtitle: null,
          url: "/courses/elearning/online-lemon-bottle-skin-booster-training",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/rme79xhtCVRI6Vic9YCHt/Cosmetic_college_lemon_bottle_.png",
          imageAlt: "Online Lemon Bottle Skin Booster Training",
        },
        {
          title: "Online Polynucleotides Training",
          subtitle: null,
          url: "/courses/elearning/online-polynucleotides-training",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/4GwvmVJEUQ7ho7sRr2Pxyy/cosmetic_college_polynucleotides.jpg",
          imageAlt: "Online Polynucleotides Training",
        },
      ],
      linkGroups: [
        {
          heading: "Online Beauty Training",
          headingUrl: "/courses/elearning/beauty/",
          items: [
            {
              label: "Brow Lamination Training",
              url: "/courses/elearning/brow-lamination/",
            },
            {
              label: "Lash Lift & Tint Training",
              url: "/courses/elearning/lash-lift-and-tint",
            },
            {
              label: "BB Glow Foundation Training",
              url: "/courses/elearning/bb-glow-foundation/",
            },
            {
              label: "View all online beauty training",
              url: "/courses/elearning/beauty/",
            },
          ],
        },
        {
          heading: "Online Aesthetics Training",
          headingUrl: "/courses/elearning/aesthetics/",
          items: [
            {
              label: "Microneedling Training",
              url: "/courses/elearning/microneedling",
            },
            {
              label: "Dermaplaning Training",
              url: "/courses/elearning/dermaplaning",
            },
            {
              label: "Chemical Skin Peels Training",
              url: "/courses/elearning/chemical-skin-peels/",
            },
            {
              label: "View all online aesthetics training",
              url: "/courses/elearning/aesthetics/",
            },
          ],
        },
        {
          heading: "Online Injectables Courses",
          headingUrl: "/courses/elearning/injectables-advanced/",
          items: [
            {
              label: "Face & Body Profhilo Training",
              url: "/courses/elearning/online-face-and-body-profhilo",
            },
            {
              label: "Jalupro Classic | HMW | Super Hydro Training",
              url: "/courses/elearning/online-jalupro-classic-or-hmw-or-super-hydro",
            },
            {
              label: "Foundation Anti Wrinkle Injections Training",
              url: "/courses/elearning/online-foundation-anti-wrinkle-injections-training-course",
            },
            {
              label: "View all online injectables training",
              url: "/courses/elearning/injectables-advanced/",
            },
          ],
        },
        {
          heading: "Online Course Packages",
          headingUrl: "/courses/elearning/bundles/",
          items: [
            {
              label: "Vitamin Injections Online Training Bundle",
              url: "/courses/elearning/vitamin-drip-and-injections-online-training-bundle",
            },
            {
              label: "Skin Booster Online Training Bundle",
              url: "/courses/elearning/skin-booster-online-training-bundle",
            },
            {
              label: "Facial & Skin Online Training Bundle",
              url: "/courses/elearning/facial-and-skin-online-training-bundle",
            },
            {
              label: "View all online course packages",
              url: "/courses/elearning/bundles/",
            },
          ],
        },
      ],
      viewAll: {
        label: "View all online courses",
        url: "/courses/elearning/",
      },
    },
    // {
    //   id: "career-pathways",
    //   label: "Career Pathways",
    //   url: "/career-pathways/",
    //   badge: null,
    //   helperText:
    //     "Follow a recommended route based on your background and goal.",
    //   featuredCards: [
    //     {
    //       title: "Non-Medic Injector Route",
    //       subtitle: null,
    //       url: "/career-pathways/non-medic-injector-route/",
    //       imageSrc:
    //         "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/4Fd21vgbsimRH63rXx4ctc/shutterstock_435284326.jpg",
    //       imageAlt: "Non-Medic Injector Route",
    //     },
    //     {
    //       title: "Level 3 → Level 7 Explained",
    //       subtitle: null,
    //       url: "/pathway-to-aesthetics/",
    //       imageSrc:
    //         "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/4Fd21vgbsimRH63rXx4ctc/shutterstock_435284326.jpg",
    //       imageAlt: "Level 2 → Level 7 Explained",
    //     },
    //     {
    //       title: "Fast Track Training",
    //       subtitle: null,
    //       url: "/courses/fast-track-training/",
    //       imageSrc:
    //         "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/4Fd21vgbsimRH63rXx4ctc/shutterstock_435284326.jpg",
    //       imageAlt: "Fast Track Training",
    //     },
    //   ],
    //   linkGroups: [
    //     {
    //       heading: "Career Pathways",
    //       headingUrl: null,
    //       items: [
    //         {
    //           label: "New to Beauty & Aesthetics",
    //           url: "/courses/career-pathways/new-to-beauty-aesthetics/",
    //         },
    //         {
    //           label: "Hair → Aesthetics Pathway",
    //           url: "/courses/career-pathways/hair-to-aesthetics/",
    //         },
    //         {
    //           label: "Beauty Therapist → Injector",
    //           url: "/courses/career-pathways/beauty-to-injector/",
    //         },
    //         {
    //           label: "Non-Medic Injector Route",
    //           url: "/courses/career-pathways/non-medic-injector-route/",
    //         },
    //         {
    //           label: "Level 2 → Level 7 Explained",
    //           url: "/courses/career-pathways/level-2-to-level-7/",
    //         },
    //       ],
    //     },
    //   ],
    //   viewAll: {
    //     label: "View all career pathways",
    //     url: "/career-pathways/",
    //   },
    //   mobilePinned: true,
    // },
    {
      id: "education",
      label: "Education",
      url: "/courses/education/",
      badge: null,
      helperText:
        "Qualifications for tutors, assessors, and quality assurance roles.",
      featuredCards: [
        {
          title: "VTCT Level 3 Award in Education and Training",
          subtitle: null,
          url: "/courses/vtct/vtct-level-3-award-in-education-and-training/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/7HTCmbqnyhQ0mfChGPfOQ8/How_to_qualify_as_a_beauty_lecturer_hero1.webp",
          imageAlt: "VTCT Level 3 Award in Education and Training",
        },
        {
          title: "VTCT Level 3 Certificate in Assessing Vocational Achievement",
          subtitle: null,
          url: "/courses/vtct/vtct-level-3-certificate-in-assessing-vocational-achievement/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/6SYck1bp3jp1hSOfTgA9Yy/Working-as-part-of-a-group-2.jpg",
          imageAlt:
            "VTCT Level 3 Certificate in Assessing Vocational Achievement",
        },
        {
          title:
            "VTCT Level 4 Award in the Internal Quality Assurance of Assessment Processes and Practice",
          subtitle: null,
          url: "/courses/vtct/level-4-award-in-the-internal-quality-assurance-of-assessment-processes/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/BpFPYH8oMPwSGQectHgyM/52502893367_a045d7194f_b.jpg",
          imageAlt:
            "VTCT Level 4 Award in the Internal Quality Assurance of Assessment Processes and Practice",
        },
        {
          title: "VTCT Teaching & Assessing Package",
          subtitle: null,
          url: "/courses/education/vtct-teaching-and-assessing-package/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/6SYck1bp3jp1hSOfTgA9Yy/Working-as-part-of-a-group-2.jpg",
          imageAlt: "VTCT Teaching & Assessing Package",
        },
      ],
      viewAll: {
        label: "View all education courses",
        url: "/courses/education/",
      },
    },
    {
      id: "clinic-models",
      label: "Clinic & Models",
      url: "/models/",
      badge: null,
      helperText:
        "Book treatments, become a model, and learn more about our student clinics.",
      featuredCards: [
        {
          title: "Become a Model",
          subtitle: null,
          url: "/models/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/4Fd21vgbsimRH63rXx4ctc/shutterstock_435284326.jpg",
          imageAlt: "Become a Model",
        },
        {
          title: "Model Club Unlimited",
          subtitle: "Monthly model treatment membership",
          url: "/models/membership/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/4Fd21vgbsimRH63rXx4ctc/shutterstock_435284326.jpg",
          imageAlt: "Model Club Unlimited membership",
        },
        {
          title: "Cosmetic Clinic",
          subtitle: null,
          url: "https://cosmeticclinic.london/",
          imageSrc:
            "https://s3.eu-west-2.amazonaws.com/assets.cosmetic.college/cms/4Fd21vgbsimRH63rXx4ctc/shutterstock_435284326.jpg",
          imageAlt: "Cosmetic Clinic",
        },
      ],
      linkGroups: [
        {
          heading: "Clinic & Models",
          headingUrl: null,
          items: [
            {
              label: "Cosmetic Clinic",
              url: "https://cosmeticclinic.london/",
              target: "_blank",
              rel: "noopener noreferrer",
            },
            {
              label: "Become a Model",
              url: "/models/",
            },
            {
              label: "Book a Consultation",
              url: "/models/consultation/",
            },
            {
              label: "Model Club Unlimited",
              url: "/models/membership/",
              badge: "New",
            },
            {
              label: "Treatment Prices",
              url: "https://www.cosmeticclinic.london/price-list/",
              target: "_blank",
              rel: "noopener noreferrer",
            },
          ],
        },
      ],
      viewAll: {
        label: "View all clinic information",
        url: "https://www.cosmeticclinic.london/price-list/",
      },
      customComponent: "clinic-models",
    },
    {
      id: "resources",
      label: "Resources",
      url: "/resources/",
      badge: null,
      helperText:
        "Practical free eBooks, tools and guides for choosing training, finding clients and growing your aesthetics practice",
      featuredCards: [],
      linkGroups: [
        {
          heading: "Free eBooks",
          headingUrl: "/resources/",
          items: [
            {
              label: "Your First 50 Clients",
              url: "/resources/your-first-50-clients/",
            },
            {
              label: "UK Aesthetics Compliance Checklist",
              url: "/resources/compliance-checklist/",
            },
            {
              label: "Price With Confidence",
              url: "/resources/price-with-confidence/",
            },
            {
              label: "Perfect Before & After",
              url: "/resources/perfect-before-and-after/",
            },
            {
              label: "Treatment Room to Business",
              url: "/resources/treatment-room-to-business/",
            },
          ],
        },
        {
          heading: "Choose by goal",
          headingUrl: "/resources/",
          items: [
            {
              label: "Build your first client base",
              url: "/resources/your-first-50-clients/",
            },
            {
              label: "Prepare to treat clients",
              url: "/resources/compliance-checklist/",
            },
            {
              label: "Grow a clinic business",
              url: "/resources/treatment-room-to-business/",
            },
          ],
        },
        {
          heading: "Explore beauty and aesthetics careers",
          headingUrl: "/career-pathways/",
          items: [
            {
              label: "Career Pathways",
              url: "/career-pathways/",
            },
          ],
        },
        {
          heading: "For students",
          headingUrl: "/account/",
          items: [
            {
              label: "Student account",
              url: withAccountUtm("/account/", {
                utm_medium: "referral",
                utm_campaign: "resources-menu",
                utm_content: "student-account",
              }),
            },
            {
              label: "Cosmetic College App",
              url: withAccountUtm(COSMETIC_COLLEGE_APP_PAGE_PATH, {
                utm_medium: "referral",
                utm_campaign: "resources-menu",
                utm_content: "cosmetic-college-app",
              }),
            },
            {
              label: "Managed Forms",
              url: MANAGED_FORMS_URL,
              target: "_blank",
              rel: "noopener noreferrer",
            },
            {
              label: "With Managed",
              url: MANAGED_PLATFORM_URL,
              target: "_blank",
              rel: "noopener noreferrer",
            },
            {
              label: "Cosmetic Careers",
              url: COSMETIC_CAREERS_URL,
              target: "_blank",
              rel: "noopener noreferrer",
            },
          ],
        },
        {
          heading: "Tools & guides",
          headingUrl: "/resources/",
          items: [
            {
              label: "Anti-Wrinkle Dosage Calculator",
              url: "/resources/toxin-to-speywood-conversion-calculator/",
            },
            {
              label: "Clinic Team & Treatment Planner",
              url: "/resources/clinic-team-and-treatment-pathway-planner/",
            },
            {
              label: "UK Aesthetic Salary & Pricing Guide",
              url: "/resources/2025-aesthetic-salary-treatment-pricing-guide-pricing-guide/",
            },
            {
              label: "All free resources",
              url: "/resources/",
            },
          ],
        },
      ],
      viewAll: {
        label: "View all free resources",
        url: "/resources/",
      },
    },
    {
      id: "more",
      label: "More",
      url: "/about/",
      badge: null,
      helperText: null,
      featuredCards: [],
      linkGroups: [
        {
          heading: "Company",
          headingUrl: "/about/",
          items: [
            {
              label: "About Us",
              url: "/about/",
            },
            {
              label: "Reviews",
              url: "/reviews/",
            },
            {
              label: "Meet The Team",
              url: "/team/",
            },
            {
              label: "Join The Team",
              url: "/careers/",
            },
            {
              label: "Finance Options",
              url: "/finance/",
            },
            {
              label: "Course Prices",
              url: "/course-prices/",
            },
            {
              label: "Aesthetics Equipment",
              url: "https://www.ventra-aesthetics.com/products",
              target: "_blank",
              rel: "noopener noreferrer",
            },
          ],
        },
        {
          heading: "Business & Partnerships",
          headingUrl: null,
          items: [
            {
              label: "Free Resources & Tools",
              url: "/resources/",
            },
            {
              label: "Train your team",
              url: "/business-training/",
            },
            {
              label: "Mentorship",
              url: "/mentorship/",
            },
            {
              label: "Clinic Team & Treatment Planner",
              url: "/resources/clinic-team-and-treatment-pathway-planner/",
            },
            {
              label: "Anti-Wrinkle Dosage Calculator",
              url: "/resources/toxin-to-speywood-conversion-calculator/",
            },
            {
              label: "Training Calendar",
              url: "/training-course-calendar/",
            },
            {
              label: "Last Minute Offers",
              url: "/last-minute-offers/",
            },
            {
              label: "Franchise Opportunities",
              url: "/franchise-with-us/",
            },
          ],
        },
        {
          heading: "Help & Support",
          headingUrl: null,
          items: [
            {
              label: "Meet With An Advisor",
              url: "/request-a-callback/",
            },
            {
              label: "Contact Course Admissions",
              url: "mailto:admissions@cosmetic.college",
            },
            {
              label: "Contact Student Support",
              url: "mailto:support@cosmetic.college",
            },
            {
              label: "Contact Models",
              url: "mailto:models@cosmetic.college",
            },
          ],
        },
        {
          heading: "Insights & Resources",
          headingUrl: "/blog/",
          items: [
            {
              label: "Blog",
              url: "/blog/",
            },
            {
              label: "Student Portal",
              url: "/sign-in/",
            },
            {
              label: "Cosmetic College App",
              url: "/cosmetic-college-app/",
            },
            {
              label: "Pathway To Aesthetics",
              url: "/pathway-to-aesthetics/",
            },
            {
              label:
                "VTCT vs CPD: Which Aesthetic Qualification Is Right for You?",
              url: "/blog/vtct-or-cpd-which-aesthetic-qualification-is-right-for-you/",
            },
          ],
        },
        // {
        //   heading: "Payment Options",
        //   headingUrl: null,
        //   items: [
        //     {
        //       label: "Payment Options",
        //       url: "/finance/",
        //     },
        //     {
        //       label: "Pay With Klarna",
        //       url: "/klarna/",
        //     },
        //     {
        //       label: "Pay With Snap Finance",
        //       url: "/snap-finance/",
        //     },
        //   ],
        // },
        {
          heading: "Social Media",
          headingUrl: null,
          items: [
            {
              label: "Facebook",
              url: "https://facebook.com/thecosmeticcollegeuk",
              target: "_blank",
              rel: "noopener noreferrer",
            },
            {
              label: "YouTube",
              url: "https://youtube.com/@cosmeticcollege",
              target: "_blank",
              rel: "noopener noreferrer",
            },
            {
              label: "Instagram",
              url: "https://instagram.com/thecosmeticcollege",
              target: "_blank",
              rel: "noopener noreferrer",
            },
            {
              label: "TikTok",
              url: "https://www.tiktok.com/@cosmeticcollege",
              target: "_blank",
              rel: "noopener noreferrer",
            },
          ],
        },
      ],
      viewAll: null,
    },
  ],
};
